import { createRef, forwardRef, Suspense } from "react";
import { usePageFragment } from "../../hooks/CmsHooks";
import SimpleLoadingSpinner from "../SimpleLoadingSpinner";
import classNames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import { cockpitComponent } from "../CockpitLayoutComponents";

const PageFragment = forwardRef((props, ref) => {
  ref = ref || createRef({});
  const { fragment, id, className } = props;
  return (
    <div ref={ref} id={id} className={classNames("page-fragment", className)}>
      <AnimatePresence>
        <Suspense fallback={<SimpleLoadingSpinner />}>
          <PageFragmentInner
            fragment={fragment}
            id={id}
            className={className}
          />
        </Suspense>
      </AnimatePresence>
    </div>
  );
});
PageFragment.displayName = "PageFragment";

const PageFragmentInner = ({ fragment: _fragment, id, className }) => {
  const fragment = usePageFragment(_fragment._id);
  if (!fragment?._id) {
    console.warn("Unknown page fragment " + _fragment._id);
    return null;
  }
  if (!Array.isArray(fragment?.content)) {
    return null;
  }

  return (
    <motion.div
      id={id + "-" + fragment._id + "-inner"}
      className={classNames("page-fragment-content", className)}
    >
      {fragment.content.map(cockpitComponent)}
    </motion.div>
  );
};

export default PageFragment;
